import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';

import { T } from '../../../../common/locale/translate';

import { prepareBreadcrumbs } from '../../common/offer_utils';

const WHITE_LOGO_PATH = '/img/amigos-logo-white.svg';
const TV_OFFERS_BACKGROUND_PATH = '/img/tvoffers/background.png';
const PHONE_NUMBER = '+48 75 753 26 01';
const MOBILE_NUMBER = '509 663 169';

const InfoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const InfoContent = styled.div`
  text-align: center;
  color: #084172;
  font-size: 3vh;
  font-weight: 600;
  max-width: 80%;
`;

const InfoComponent = ({ children }) => (
  <InfoWrapper>
    <InfoContent>{children}</InfoContent>
  </InfoWrapper>
);

class TvOffers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshKey: 0
    };
    this.refreshInterval = null;
  }

  componentDidMount() {
    this.checkAndStartRefreshInterval();
  }

  componentDidUpdate() {
    this.checkAndStartRefreshInterval();
  }

  componentWillUnmount() {
    this.stopRefreshInterval();
  }

  checkAndStartRefreshInterval = () => {
    if (
      !this.props.groupedTvOffers ||
      this.props.groupedTvOffers.length === 0
    ) {
      this.startRefreshInterval();
    } else {
      this.stopRefreshInterval();
    }
  };

  startRefreshInterval = () => {
    if (!this.refreshInterval) {
      this.refreshInterval = setInterval(() => {
        window.location.reload();
        this.setState(prevState => ({ refreshKey: prevState.refreshKey + 1 }));
      }, 5000);
    }
  };

  stopRefreshInterval = () => {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  };
  render = () => {
    const { groupedTvOffers, category, info } = this.props;

    if (!groupedTvOffers || groupedTvOffers.length === 0) {
      return (
        <TvOffersWrapper key={this.state.refreshKey}>
          <Header>
            <Title>{category.name}</Title>
            <Logo src={WHITE_LOGO_PATH} />
          </Header>
          <InfoComponent>{info}</InfoComponent>
        </TvOffersWrapper>
      );
    } else {
      return (
        <TvOffersWrapper>
          <Header>
            <Title>{category.name}</Title>
            <Logo src={WHITE_LOGO_PATH} />
          </Header>

          <Carousel
            className="curiosity-slider"
            showArrows={false}
            showThumbs={false}
            emulateTouch={false}
            showIndicators={true}
            autoPlay={true}
            showStatus={false}
            infiniteLoop={true}
            axis="horizontal"
            stopOnHover={false}
            transitionTime={1000}
            interval={20000}
          >
            {groupedTvOffers.map((group, groupIdx) => (
              <OffersSwiper key={groupIdx}>
                {group.map(offer => {
                  const breadcrumbs = prepareBreadcrumbs(offer.subject);

                  return (
                    <OfferWrapper
                      key={`${offer.tv_offer.id}_${offer.tv_offer.url}`}
                    >
                      {this.renderOfferCategories(offer)}
                      <OverflowWrapper>
                        <HotelInfo>
                          <LeftHotelPanel>
                            <Thumbnail src={offer.tv_offer.thumbnail.url} />
                            <HotelName>
                              {offer.subject.name}&nbsp;
                              {offer.subject.rating && (
                                <span
                                  className={`stars stars-${
                                    offer.subject.rating
                                  }`}
                                />
                              )}
                            </HotelName>
                          </LeftHotelPanel>
                          <RightHotelPanel>
                            <Breadcrumbs>
                              <MainBreadcrumb>
                                {breadcrumbs.length ? breadcrumbs[0] : null}
                              </MainBreadcrumb>
                              <RestBreadcrumbs>
                                {breadcrumbs.length > 1
                                  ? breadcrumbs.slice(1).join(', ')
                                  : null}
                              </RestBreadcrumbs>
                            </Breadcrumbs>
                            <Price>
                              <span>{T('from')} </span>
                              {Math.ceil(
                                offer.offer_check && offer.offer_check.price_pln
                                  ? offer.offer_check.price_pln
                                  : offer.price_pln
                              )}{' '}
                              {T('pln_per_person')}
                            </Price>
                          </RightHotelPanel>
                        </HotelInfo>

                        <StyledSeparator />

                        <OfferInfo>
                          <LeftInfoPanel>
                            {offer.departure_date &&
                              offer.return_date && (
                                <div>
                                  <i className="fa fa-calendar" />
                                  {moment
                                    .utc(offer.departure_date)
                                    .format('DD.MM.YY')}
                                  {'-'}
                                  {moment
                                    .utc(offer.return_date)
                                    .format('DD.MM.YY')}
                                </div>
                              )}
                            {offer.flights &&
                              offer.flights.length &&
                              offer.flights[0].departure_airport_name && (
                                <div>
                                  <i className="fa fa-plane" />
                                  {T('departure_colon')}{' '}
                                  {offer.flights[0].departure_airport_name}
                                </div>
                              )}
                            {offer.boards &&
                              offer.boards.length &&
                              offer.boards[0].name && (
                                <div>
                                  <i className="fa fa-cutlery" />
                                  {offer.boards[0].name}
                                </div>
                              )}
                          </LeftInfoPanel>
                          {offer.qr_code && (
                            <RightInfoPanel>
                              <span>{T('scan_qr')}</span>
                              <QRCode
                                src={`data:image/png;base64,${offer.qr_code}`}
                              />
                            </RightInfoPanel>
                          )}
                        </OfferInfo>
                      </OverflowWrapper>
                    </OfferWrapper>
                  );
                })}
              </OffersSwiper>
            ))}
          </Carousel>
          <Footer>
            <FooterColumn>
              <FooterElement>{T('site_name')}</FooterElement>
            </FooterColumn>
            <FooterColumn>
              <FooterElement>
                <i className="fa fa-phone" />
                {PHONE_NUMBER}
              </FooterElement>
              <FooterElement>
                <i className="fa fa-mobile" />
                {MOBILE_NUMBER}
              </FooterElement>
            </FooterColumn>
          </Footer>
        </TvOffersWrapper>
      );
    }
  };

  renderOfferCategories = offer => (
    <OfferCategories>
      {offer.is_allinclusive && (
        <OfferCategory className="offer-category all-inclusive">
          {' '}
          {T('all_inclusive')}{' '}
        </OfferCategory>
      )}
      {offer.is_lastminute && (
        <OfferCategory className="offer-category last-minute">
          {' '}
          {T('last_minute')}{' '}
        </OfferCategory>
      )}
      {offer.is_firstminute && (
        <OfferCategory className="offer-category first-minute">
          {' '}
          {T('first_minute')}{' '}
        </OfferCategory>
      )}
    </OfferCategories>
  );
}

const OffersSwiper = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 4vw;
  row-gap: 4vw;
  place-items: center;
  justify-content: space-between;
  margin: 0 6vw !important;
`;

const OfferWrapper = styled.div`
  height: 100%;
  width: 100%;
  background: #ffffff;
  border-radius: 1vh;
  position: relative;
`;

const OverflowWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  color: #084172;
  padding: 2vh !important;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 1vh;
`;

const Thumbnail = styled.img`
  && {
    height: 14vh;
    margin-left: -4vh;
    border-radius: 0 1vh 1vh 0;
    object-fit: cover;
  }
`;

const HotelInfo = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 2;
`;

const LeftHotelPanel = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  row-gap: 1.5vh;
`;

const HotelName = styled.div`
  font-weight: 600;
  text-align: left;
  font-size: 1.5vh;
  max-height: 3rem;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RightHotelPanel = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  row-gap: 1vh;
  text-align: left;
`;

const QRCode = styled.img`
  &&&& {
    height: 100%;
    max-height: 6vh;
    width: auto;
    image-rendering: pixelated;
  }
`;

const Breadcrumbs = styled.div``;

const MainBreadcrumb = styled.div`
  text-align: left;
  font-weight: 600;
  font-size: 2vh;
  text-transform: uppercase;
`;

const RestBreadcrumbs = styled.div`
  text-align: left;
  font-weight: 600;
  font-size: 1.5vh;
  text-transform: uppercase;
  color: #0797af;
`;

const Price = styled.div`
  text-align: left;
  font-weight: 600;
  font-size: 3vh;

  span {
    font-weight: 500;
  }
`;

const OfferInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  align-items: stretch;
  column-gap: 1vh;
`;

const LeftInfoPanel = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.3vh;
  text-align: left;
  text-transform: capitalize;
  row-gap: 0.3vh;
  flex-basis: 90%;
  justify-content: end;
  row-gap: 0.5vh;

  i.fa {
    width: 2vh;
  }
`;

const RightInfoPanel = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1vh;
  font-size: 1.2vh;
  align-items: end;
  text-align: left;
`;

const TvOffersWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .curiosity-slider {
    background: rgba(0, 0, 0, 0.3) url(${TV_OFFERS_BACKGROUND_PATH});
    background-size: cover;
    background-position: center;
    background-blend-mode: darken;
    height: 0;
    flex-grow: 5;

    .carousel-slider {
      height: 100%;
      display: flex;

      .slider-wrapper {
        height: 87.5%;

        ul.slider {
          height: 100%;
        }
      }

      .dot {
        background: #ffffff 0% 0% no-repeat padding-box !important;
        border: 1px solid #707070 !important;
        opacity: 0.58 !important;
        width: 1.75vh !important;
        height: 1.75vh !important;

        &.selected {
          opacity: 1 !important;
        }
      }
    }
  }
`;

const Header = styled.div`
  padding: 2vh 6vw;
  background: #084172;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.div`
  font-size: 4vh;
  line-height: 4vh;
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
`;

const Logo = styled.img`
  max-height: 7.5vh;
`;

const StyledSeparator = styled.div`
  border-top: 0.1vw dashed #aaaaaa;
`;

const Footer = styled.div`
  padding: 2vh 6vw;
  background: #084172;
  display: flex;
  justify-content: space-between;
`;

const FooterColumn = styled.div`
  display: flex;
  column-gap: 1vw;
`;

const FooterElement = styled.div`
  font-size: 2vh;
  line-height: 2vh;
  color: #ffffff;
  text-transform: uppercase;

  i.fa {
    margin: 0 10px;
  }
`;

const OfferCategories = styled.div`
  position: absolute;
  top: 3vh;
  left: -4vh;
  text-align: center;
`;

const OfferCategory = styled.span`
  && {
    display: block;
    font-size: 0.5rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #fff;
    width: 110px;
    box-sizing: border-box;
    padding: 0.35rem 0;
    margin: 0.3rem 0;
  }
`;

export default TvOffers;



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/tv_offers.jsx